import { Airhelp, AirhelpPlus, AirhelpPlusItalics } from "@airhelp/react";

export const logos = {
  AirhelpLogo: Airhelp,
  AirhelpPlusLogo: AirhelpPlus,
  AirhelpPlusItalicsLogo: AirhelpPlusItalics,
};
